<template>
  <div class="content-block">
    <div class="content-block-title">{{$lang.messages.sites.title}}</div>
    <div v-if="showInfoBlock" class="info-block flex-v-center">
      <button @click="showInfoBlock = false" class="btn-close btn-icon"><i class="icon-close-small"></i></button>
      <img src="../assets/img/did-you-know.svg" alt="did you know" class="mr-1">
      <div class="info-block-text">
        {{$lang.messages.sites.sites_description}}
      </div>
    </div>
    <div class="row mt-3 mb-2">
      <div class="col-md-6">
        <div class="flex-reverse-xs">
          <Checkbox :checkboxModel="{'allowKidRequestSite':allowKidRequestSite}" @changecheckbox="updateSettings"/>
          <span class="ml-1 ml-0-xs mr-auto-xs content-block-subtitle"> {{$lang.messages.sites.allow_kid_to_request}}
            <v-popover
                popoverWrapperClass="popover-wrapper"
                popoverClass="inline-block"
                trigger="hover focus"
                placement="top"
            >
            <span class="info-icon"></span>
            <template slot="popover">
              To use this feature you have to check if your operating system supports notification displaying via the selected browser and the required option in system preferences was turned on
              <button class='btn mt-1 btn-sm btn-main' @click='sendTestNotification'>Send test notification</button>
            </template>
          </v-popover>
<!--            <span class="info-icon" v-tooltip="{content: `${$lang.messages.sites.allow_kid_to_request_tooltip} <button class='btn btn-sm btn-main' @click='sendTestNotification'>Send test notification</button>`}"></span>-->
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <p class="text-muted">
          {{$lang.messages.sites.allow_kid_to_request_desc}}
        </p>
      </div>
    </div>
    <hr>
    <div class="flex flex-between mt-2 block-xs">
      <div class="content-block-subtitle">{{$lang.messages.sites.add_links}}</div>
      <div class="text-muted mb-1">{{$lang.messages.sites.add_links_desc}}</div>
    </div>
    <div class="links-wrapper mb-2">
      <Link
          v-for="link in links"
          :key="link.id"
          v-bind="link"
          v-on:removelink="removeLink"
          v-on:editlink="editLink"
      />
      <span v-if="links && links.length < maxLinks || !links" class="btn btn-secondary" @click="showAddLinkDialog()">+</span>
    </div>
    <hr>
    <div class="content-block-subtitle mt-2">{{$lang.messages.sites.useful_websites}}</div>
    <RecommendedLink
        v-for="link in recommendedList"
        :key="link.key"
        v-bind="link"
        v-on:removerecommendedlink="removeRecommendedlink(link)"
        v-on:addtolinks="addLink(link)"
    />
    <AddLinkModal
        :linktitle="editLinkTitle"
        :linkurl="editLinkUrl"
        :linkId="editLinkId"
        :kidAge="kidage"
        v-if="showAddLinkModal"
        v-on:addlink="addLink"
        v-on:hidemodal="showAddLinkModal = false"/>
    <div v-if="showTooMuchLinksModal" class="modal" @click.self="showTooMuchLinksModal = false">
      <div class="modal-dialog modal-dialog-sm">
        <div class="modal-title">{{$lang.messages.sites.oops}} <span class="modal-close" @click="showTooMuchLinksModal = false"><i class="icon-close"></i></span></div>
        <div class="flex-v-center modal-content flex-column-xs">
          <img src="../assets/img/gena.svg" width="196" height="150" alt="too much links" class="mr-1 mb-xs-1">
          <div class="text-center-xs">
            <p class="text-md"><b>{{$lang.messages.sites.can_add_10_links}}</b></p>
            <p>{{$lang.messages.sites.to_add_remove}}</p>
          </div>
        </div>
        <div class="modal-footer text-right">
          <button class="btn btn-main" @click="closeTooMushLinksModal">{{$lang.messages.ok}}</button>
        </div>
      </div>
    </div>
    <div v-if="showAlreadyExistLinkModal" class="modal" @click.self="showAlreadyExistLinkModal = false">
      <div class="modal-dialog modal-dialog-sm">
        <div class="modal-title">{{$lang.messages.sites.oops}} <span class="modal-close" @click="showAlreadyExistLinkModal = false"><i class="icon-close"></i></span></div>
        <div class="modal-content">
          <div>
            <p>{{$lang.messages.url_exists}}</p>
            <p class="recommended -small"><span class="recommended-title">{{alreadyExistLinkUrl}}</span></p>
            <p>{{$lang.messages.links_list}}</p>
          </div>
        </div>
        <div class="modal-footer text-right">
          <button class="btn btn-main" @click="showAlreadyExistLinkModal = false">{{$lang.messages.ok}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from './Checkbox';
import AddLinkModal from './AddLinkModal';
import Link from './Link';
import RecommendedLink from './RecommendedLink';
import {recommendedLinks, notAvailableForMobileDomains} from "../helpers/configs";
import {reportEvent} from "@/helpers/utils";

export default {
  name: 'Sites',
  props: ['allowKidRequestSite', 'links', 'tooMuchLinks', 'userRemovedRecommended', 'kidage', 'isPremium'],
  data: function (){
    return {
      maxLinks: 10,
      showAddLinkModal: false,
      showTooMuchLinksModal: this.tooMuchLinks || false,
      alreadyExistLinkUrl: '',
      showAlreadyExistLinkModal: false,
      showInfoBlock: true,
      editLinkTitle: '',
      editLinkUrl: '',
      editLinkId: null,
      recommendedLinks,
    }
  },
  computed: {
    recommendedList () {
      let removeFromRecommended = []
      this.links.forEach(link => removeFromRecommended.push(link.url))
      this.userRemovedRecommended.forEach(link => removeFromRecommended.push(link));
      const isAndroid = window.Android;
      return this.recommendedLinks.filter((item) => {
        const notInRemovedRecommended = !removeFromRecommended.includes(item.url);
        if (!isAndroid) {
          return notInRemovedRecommended;
        }
        return notInRemovedRecommended && !notAvailableForMobileDomains.includes(item.url);
      })
    }
  },
  methods: {
    sendTestNotification () {
      const browser = window.browser || window.chrome;
      if (browser) {
        browser.runtime.sendMessage(localStorage.getItem('extID'), {sendTestNotification: true});
      } else {
        window.postMessage({
          direction: 'from-page-script',
          message: 'test notification',
        }, "*");
      }
    },
    updateSettings(keyName, value){
      this.$emit('updatesettings', {[keyName]: value})
    },
    addLink (link, editLinkId) {
      this.showAddLinkModal = false
      if (this.links && editLinkId) {
        const index = this.links.findIndex(item => item.id === editLinkId)
        this.links[index].title = link.title
        this.links[index].icon = link.icon
        this.links[index].url = link.url
        this.editLinkId = false
        this.$emit('updatesettings', {links: this.links})
        reportEvent('editCustomLink', {'isRemote': localStorage.getItem('isRemote')})
      } else {
        const index = this.links ? this.links.findIndex(item => item.url === link.url) : null
        if (this.links && this.links.length === this.maxLinks) {
          this.showTooMuchLinksModal = true
          return false
        } else if (index != -1) {
          this.alreadyExistLinkUrl = link.url
          this.showAlreadyExistLinkModal = true
        } else {
          this.$emit('updatesettings', {links: [...this.links, link]})
          reportEvent('addCustomLink', {'isRemote': localStorage.getItem('isRemote')})
        }
      }
    },
    editLink (link) {
      this.editLinkTitle = link.title
      this.editLinkUrl = link.url
      this.editLinkId = link.id
      this.showAddLinkModal = true
    },
    removeLink (link) {
      const index = this.links.findIndex(item => item.id === link)
      this.links.splice(index, 1)
      this.$emit('updatesettings', {links: this.links})
      reportEvent('removeCustomLink', {'isPremium': this.isPremium, 'isRemote': localStorage.getItem('isRemote')})
    },
    removeRecommendedlink (link) {
      const index = this.userRemovedRecommended.findIndex(item => item === link.url)
      if (index === -1){
        this.userRemovedRecommended.push(link.url)
      }
      this.$emit('updatesettings', {userRemovedRecommended: this.userRemovedRecommended})
      reportEvent('removeRecommendedLink', {'isPremium': this.isPremium, 'isRemote': localStorage.getItem('isRemote')})
    },
    showAddLinkDialog () {
      this.editLinkTitle = ''
      this.editLinkUrl = 'https://'
      this.editLinkId = null
      this.showAddLinkModal = true
    },
    closeTooMushLinksModal() {
      this.showTooMuchLinksModal = false
      this.$emit('removetoomuchlinks')
    }
  },
  components: {
    RecommendedLink,
    AddLinkModal,
    Checkbox,
    Link
  }
}
</script>


